import React from 'react';
import { createRoot } from "react-dom/client"
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const domNode = document.getElementById("root")
const root = createRoot(domNode!);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)
// const root = createRoot(document.getElementById("root"));
// root.render(
//   <React.StrictMode>
//     <App />
//   </React.StrictMode>
// )

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
